
import ComapanyTable from 'components/Settings/Company';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const Companies = () => {
	const selectedCompanyPermission = useSelector(
		(state: any) => state?.userProfile?.data?.permissions
	);
		const isRolePermission = checkPermission(selectedCompanyPermission, {
			permissionName: 'Company Setup',
			permission: ['view'],
		});

	return <div>{isRolePermission  && <ComapanyTable />}</div>;
};
